import { useState, useEffect, useCallback } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardHeader,
} from "@material-ui/core";

import HeaderClientes from "components/_refactor/headers/clients";
import ClearButton from "components/_refactor/button/clear";
import StructureFields from "components/_refactor/fields/structure";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import InputText from "components/_refactor/text/input";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import LoadingData from "components/Loading/LoadingData";
import OccurencesDialog from "components/Dialogs/OccurencesDialog";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";
import componentStyles from "assets/theme/views/admin/react-bs-table";

//Karsten
import PeriodField, {
  getPeriodLabel,
} from "components/_refactor/fields/period-field";
import useForm from "hooks/form";

import DialogCriacaoObservacaoOcorrencia from "components/Dialogs/DialogCriacaoObservacaoOcorrencia";
import OrderDetailsTimelineDialog from "components/Dialogs/OrderDetailsTimelineDialog";
import Api from "lib/api/httpRequestHelper";
import { TableConsultaPedidosOmni } from "./table/TableConsultaPedidosOmni";
import moment from "moment";
import { IsMobile900, IsMobile } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);

const today = new Date().toISOString().slice(0, 10);

const situationOptions = [
  {
    name: "Entregue",
    value: "entregue",
    id: 1,
  },
  {
    name: "Não Entregue",
    value: "naoentregue",
    id: 2,
  },
  {
    name: "Todos",
    value: "todos",
    id: 3,
  },
];

const typesOptions = [
  {
    name: "Ecommerce",
    value: "ecommerce",
    id: 1,
  },
  {
    name: "Marketplace",
    value: "marketplace",
    id: 2,
  },
  {
    name: "Prateleira Infinita",
    value: "pratinf",
    id: 3,
  },
  {
    name: "Retire na Loja",
    value: "retire",
    id: 4,
  },
  {
    name: "Todos",
    value: "todos",
    id: 5,
  },
];

const descriptionOptions = [
  {
    id: 1,
    value: "DEVOLUÇÃO",
    observacao: "Devolução",
  },
  {
    id: 2,
    value: "EXTRAVIO",
    observacao: "Extravio",
  },
  {
    id: 3,
    value: "EM ROTA",
    observacao: "Em rota",
  },
  {
    id: 4,
    value: "EM TRATATIVA",
    observacao: "Em tratativa",
  },
  {
    id: 5,
    value: "FRAUDE",
    observacao: "Fraude",
  },
];

const orderOptions = [
  {
    value: "dataAsc",
    name: "Data de Previsão de Entrega (ascendente)",
  },
  {
    value: "dataDesc",
    name: "Data de Previsão de Entrega (descendente)",
  },
];

function ConsultaPedidosOmni() {
  const snackbar = useSnackbar();
  const classes = { ...useStyles(), ...useStylesCardDeck() };

  const [resultados, setResultados] = useState(null);
  const [searching, setSearching] = useState(false);
  const [lastSearchParams, setLastSearchParams] = useState(null);
  const [structureFilters, setStructureFilters] = useState(null);
  const [structureLoading, setStructureLoading] = useState([]);
  const [storeListItens, setStoreListItens] = useState([]);

  const { values, handleChange, errors } = useForm({
    nrNf: "",
    nrPedido: "",
    statusPedido: "",
    nrPedidoCliente: "",
    tipoPedido: typesOptions[4],
    situacaoPedido: situationOptions[2],
    periodo: null,
    dataInicialEmissao: today,
    dataFinalEmissao: today,
    ordenacao: orderOptions[0],
  });
  const [labelHeader, setLabelHeader] = useState("");
  const [ocorrenciasNF, setOcorrenciasNF] = useState(null);
  const [statusOrderOptions, setStatusOrderOptions] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);
  const [ocorrenciaRegistroRow, setOcorrenciaRegistroRow] = useState(null);
  const [clearFilters, setClearFilters] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [errorMessageMany, setErrorMessageMany] = useState(false);
  const [errorMessageNotFound, setErrorMessageNotFound] = useState("");
  const [hasNoBrand, setHasNoBrand] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);
  const [selectedObservation, setSelectedObservation] = useState([]);

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();
  const itemXS = isMobile ? 12 : isMobile900 ? 6 : 3;
  const itemXSOrder = isMobile ? 12 : isMobile900 ? 6 : 6;

  const fetchOrderStatusOptions = useCallback(async () => {
    await Api.get("order-status", "order", "", true)
      .then((res) => {
        if (res.Success) {
          const statusResult = res.Result;
          const statusList = [];

          statusResult?.map((status) => {
            if (status?.StatusEco) {
              let changeStatusText = status.StatusEco;
              changeStatusText = changeStatusText
                ?.toLowerCase()
                ?.replace(/(?:^|\s)\S/g, function (a) {
                  return a?.toUpperCase();
                });
              const newState = {
                CodigoStatus: status.CodigoStatus,
                Descricao: status.Descricao,
                IndicaVendaLink: status.IndicaVendaLink,
                StatusApp: status.StatusApp,
                StatusEco: changeStatusText,
              };
              statusList.push(newState);
            }
          });
          setStatusOrderOptions(statusList);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      });
  }, [snackbar]);

  const handleSearch = async ({ page = 1, sizePerPage = 25 }) => {
    const {
      nrNf,
      nrPedido,
      nrPedidoCliente,
      tipoPedido,
      situacaoPedido,
      periodo,
      dataInicialEmissao,
      dataFinalEmissao,
      statusPedido,
      ordenacao,
    } = values;

    setLastSearchParams(null);
    const listObservations = [];
    selectedObservation?.map((observation) => {
      return listObservations.push(observation.value);
    });

    setResultados(null);
    setSearching(true);
    setCancelLoading(false);

    const initialFormat = moment(dataInicialEmissao).format("YYYY-MM-DD");
    const finalFormat = moment(dataFinalEmissao).format("YYYY-MM-DD");

    setLastSearchParams({
      isPessoaLoja: structureFilters?.idLoja,
      idMarca: structureFilters?.idMarca ? structureFilters?.idMarca : "TODAS",
      nrNf: nrNf,
      nrPedido: nrPedido,
      nrPedidoCliente: nrPedidoCliente,
      tipoPedido: tipoPedido.value,
      situacaoPedido: situacaoPedido.value,
      status: statusPedido.StatusEco
        ? statusPedido.StatusEco.toUpperCase()
        : "",
      dtIni: initialFormat,
      dtFim: finalFormat,
      observacao: listObservations.join(),
    });

    const verifyBrand = structureFilters?.idMarca
      ? structureFilters?.idMarca
      : "TODAS";
    const urlDefault = `?nrNf=${nrNf}&nrPedido=${nrPedido}&nrPedidoCliente=${nrPedidoCliente}&idPessoaLoja=${
      structureFilters?.idLoja
    }&page=${page - 1}&pageSize=${sizePerPage}`;
    const url = `&idMarca=${verifyBrand}&tipoPedido=${
      tipoPedido.value
    }&situacaoPedido=${situacaoPedido.value}&status=${
      statusPedido.StatusEco ? statusPedido.StatusEco.toUpperCase() : ""
    }&dtIni=${initialFormat}&dtFim=${finalFormat}&observacao=${listObservations.join()}&ordem=${
      ordenacao.value
    }`;

    setLoading(true);
    await Api.get(
      "list-ecommerce-orders",
      "order",
      urlDefault + (!nrNf && !nrPedido && !nrPedidoCliente ? url : ""),
      true
    )
      .then((res) => {
        if (res.cause) {
          if (
            res.cause.errorMessage ===
            "Unable to expand length of this stream beyond its capacity."
          ) {
            setErrorMessageMany(true);
          } else {
            setErrorMessage(true);
          }
        } else {
          if (res.Result?.ListPedidos?.length > 0) {
            setLabelHeader(
              `Pedidos ${getPeriodLabel({
                period: periodo?.value,
                initialDate: dataInicialEmissao,
                finalDate: dataFinalEmissao,
              })}`
            );
          }

          setResultados(res.Result.ListPedidos);

          setTotalRegisters(res.Result.TotalRegistros);
          setCurrentSizePerPage(sizePerPage);
          setCurrentPage(page);
        }
      })
      .catch((error) => {
        setErrorMessageNotFound(error);      })
      .finally(() => {
        setSearching(false);
        setLoading(false);
      });
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setStructureLoading(true);
    setSearching(true);
    handleChange({
      target: {
        name: "periodo",
        value: null,
      },
    });
    handleChange({
      target: {
        name: "nrNf",
        value: "",
      },
    });
    handleChange({
      target: {
        name: "nrPedido",
        value: "",
      },
    });
    handleChange({
      target: {
        name: "nrPedidoCliente",
        value: "",
      },
    });
    handleChange({
      target: {
        name: "statusPedido",
        value: "",
      },
    });
    handleChange({
      target: {
        name: "tipoPedido",
        value: typesOptions[4],
      },
    });
    handleChange({
      target: {
        name: "situacaoPedido",
        value: situationOptions[2],
      },
    });
    handleChange({
      target: {
        name: "ordenacao",
        value: orderOptions[0],
      },
    });
    setSelectedObservation([]);
    setStructureLoading(false);
    setSearching(false);

    setTimeout(() => {
      setClearFilters(false);
    }, 500);
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setSearching(false);
    setResultados(null);
  };

  const handleVerifyRequiredInputs = () => {
    if (
      structureFilters?.idMarca ||
      values.nrPedido ||
      values.nrPedidoCliente ||
      values.nrNf ||
      values.statusPedido
    ) {

      return handleSearch({
        page: 1,
        sizePerPage: currentSizePerPage,
      });
    } else {
      if (
        !structureFilters?.idMarca &&
        !values.nrPedido &&
        !values.nrPedidoCliente &&
        !values.nrNf &&
        !values.statusPedido
      ) {
        setHasNoBrand(true);
      }
    }
  };

  const onObservationsChange = (newValue) => {
    if (
      newValue?.length === 0 &&
      (selectedObservation?.length === 0 || selectedObservation?.length === 1)
    ) {
      setSelectedObservation([]);
    }

    if (newValue?.length !== 0 && newValue !== "all") {
      setSelectedObservation(newValue);
    }
  };

  useEffect(() => {
    if (errorMessage && !cancelLoading) {
      snackbar.showMessage(
        "Ocorreu um erro ao buscar pedidos. Verifique os parâmetros informados e/ou tente novamente mais tarde.",
        {
          severity: "error",
        }
      );
    }

    if (errorMessageMany && !cancelLoading) {
      snackbar.showMessage(
        "A busca com os parâmetros utilizados encontrou muitos registros. Simplifique sua busca e tente novamente.",
        {
          severity: "info",
          autoHideDuration: 10000,
        }
      );
    }

    if (errorMessageNotFound !== "" && !cancelLoading) {
      snackbar.showMessage(errorMessageNotFound, {
        severity: "error",
      });
    }
  }, [cancelLoading, errorMessage, errorMessageMany, errorMessageNotFound]);

  useEffect(() => {
    if (
      structureFilters?.idMarca ||
      values.nrPedido ||
      values.nrPedidoCliente ||
      values.nrNf ||
      values.statusPedido
    ) {
      setHasNoBrand(false);
    }
  }, [values, structureFilters]);

  useEffect(() => {
    fetchOrderStatusOptions();
  }, []);

  return (
    <>
      <HeaderClientes section="Consulta de Pedidos Omni" subsection="Pedidos" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Filtros"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <StructureFields
                    clearFilters={clearFilters}
                    onStructureFieldsChange={setStructureFilters}
                    disableAll={searching}
                    onStructureFieldsLoad={setStructureLoading}
                    requiredFields={["brand"]}
                    fieldsOrder={["store"]}
                    hideFields={["channel", "representative", "economicGroup"]}
                    handleSearch={handleVerifyRequiredInputs}
                  />
                  <Grid
                    item
                    xs={values.periodo?.value === "Outros" ? "12" : itemXS}
                  >
                    <PeriodField
                      label="Período do Pedido"
                      required
                      value={values.periodo}
                      onChange={(option) =>
                        handleChange({
                          target: {
                            name: "periodo",
                            value: option,
                          },
                        })
                      }
                      initialDate={values.dataInicialEmissao}
                      finalDate={values.dataFinalEmissao}
                      setInitialDate={(value) =>
                        handleChange({
                          target: {
                            name: "dataInicialEmissao",
                            value,
                          },
                        })
                      }
                      setFinalDate={(value) =>
                        handleChange({
                          target: {
                            name: "dataFinalEmissao",
                            value,
                          },
                        })
                      }
                      disabled={searching}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      label="Situação do Pedido"
                      onChange={(value) => {
                        if (value !== "all") {
                          handleChange({
                            target: { name: "situacaoPedido", value },
                          });
                        } else {
                          handleChange({
                            target: {
                              name: "situacaoPedido",
                              value: situationOptions[2],
                            },
                          });
                        }
                      }}
                      value={values.situacaoPedido}
                      options={situationOptions}
                      disabled={searching}
                      optionLabelKey="name"
                      optionIdKey="id"
                      customTooltipText={(option) => {
                        option.name;
                      }}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      label="Tipo de Pedido"
                      onChange={(value) => {
                        if (value !== "all") {
                          handleChange({
                            target: { name: "tipoPedido", value },
                          });
                        } else {
                          handleChange({
                            target: {
                              name: "tipoPedido",
                              value: typesOptions[4],
                            },
                          });
                        }
                      }}
                      value={values.tipoPedido}
                      options={typesOptions}
                      disabled={searching}
                      optionLabelKey="name"
                      optionIdKey="id"
                      customTooltipText={(option) => {
                        option.name;
                      }}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <InputText
                      label="Número do Pedido"
                      value={values.nrPedido}
                      onChange={(e) => {
                        handleChange({
                          target: {
                            name: "nrPedido",
                            value: e.target.value.slice(0, 50),
                          },
                        });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleVerifyRequiredInputs();
                        }
                      }}
                      disabled={searching}
                      error={!!errors.nrPedido}
                      errorMessage={errors.nrPedido}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <InputText
                      label="Número do Pedido Cliente"
                      value={values.nrPedidoCliente}
                      onChange={(e) => {
                        handleChange({
                          target: {
                            name: "nrPedidoCliente",
                            value: e.target.value.slice(0, 300),
                          },
                        });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleVerifyRequiredInputs();
                        }
                      }}
                      disabled={searching}
                      error={!!errors.nrPedidoCliente}
                      errorMessage={errors.nrPedidoCliente}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <InputText
                      label="Número da Nota"
                      type="number"
                      value={values.nrNf}
                      onChange={(e) => {
                        handleChange({
                          target: {
                            name: "nrNf",
                            value: e.target.value.slice(0, 50),
                          },
                        });
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleVerifyRequiredInputs();
                        }
                      }}
                      disabled={searching}
                      error={!!errors.nrNf}
                      errorMessage={errors.nrNf}
                    />
                  </Grid>
                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      label="Status do Pedido"
                      onChange={(value) => {
                        if (value !== "all") {
                          handleChange({
                            target: { name: "statusPedido", value },
                          });
                        } else {
                          handleChange({
                            target: { name: "statusPedido", value: "" },
                          });
                        }
                      }}
                      value={values.statusPedido}
                      options={statusOrderOptions}
                      disabled={searching}
                      optionLabelKey="StatusEco"
                      optionIdKey="StatusEco"
                      loading={clearFilters}
                      customTooltipText={(option) => {
                        option.StatusEco;
                      }}
                    />
                  </Grid>
                  <Grid item xs={itemXSOrder}>
                    <AutoCompleteField
                      label="Descrição"
                      onChange={onObservationsChange}
                      value={selectedObservation}
                      options={descriptionOptions}
                      disabled={searching}
                      optionLabelKey="observacao"
                      optionIdKey="id"
                      loading={clearFilters}
                      noOptionsText="Sem opções de observações"
                      multiple
                    />
                  </Grid>
                  <Grid item xs={itemXSOrder}>
                    <AutoCompleteField
                      label="Ordenar por"
                      onChange={(value) => {
                        if (value !== "all") {
                          handleChange({
                            target: { name: "ordenacao", value },
                          });
                        } else {
                          handleChange({
                            target: {
                              name: "ordenacao",
                              value: orderOptions[0],
                            },
                          });
                        }
                      }}
                      value={values.ordenacao}
                      options={orderOptions}
                      disabled={searching}
                      loading={clearFilters}
                      optionLabelKey="name"
                      optionIdKey="value"
                      customTooltipText={(option) => {
                        option.name;
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      style={
                        isMobile || isMobile900
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      color="default"
                      variant="contained"
                      onClick={handleVerifyRequiredInputs}
                      disabled={
                        searching ||
                        Object.entries(errors).length > 0 ||
                        structureLoading.length > 0
                      }
                    >
                      {searching ? "Pesquisando..." : "Pesquisar"}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <ClearButton
                      fullWidth={true}
                      disable={searching}
                      onClick={() => handleClearFilters()}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <LoadingData
              searching={searching}
              onClick={() => handleStopSearching()}
              classes={classes.root}
              label="Buscando dados..."
            />
          </Grid>
          {resultados && !loading && !cancelLoading ? (
            <Grid item xs={12}>
              <TableConsultaPedidosOmni
                dataTable={resultados}
                setOcorrenciaRegistroRow={setOcorrenciaRegistroRow}
                setOrderDetails={setOrderDetails}
                totalRegisters={totalRegisters}
                currentPage={currentPage}
                currentSizePerPage={currentSizePerPage}
                handleSearch={handleSearch}
                labelHeader={labelHeader}
                lastSearchParams={lastSearchParams}
              />
            </Grid>
          ) : null}
        </Grid>
        {ocorrenciasNF && !cancelLoading ? (
          <OccurencesDialog
            data={ocorrenciasNF}
            handleClose={() => setOcorrenciasNF(null)}
            dialogTitle={`Ocorrências de Entrega do Pedido ${ocorrenciasNF.NrPedido}`}
          />
        ) : null}
        {ocorrenciaRegistroRow && !cancelLoading ? (
          <DialogCriacaoObservacaoOcorrencia
            descriptionOptions={descriptionOptions}
            data={ocorrenciaRegistroRow}
            handleClose={() => setOcorrenciaRegistroRow(null)}
          />
        ) : null}
        {orderDetails && !cancelLoading ? (
          <OrderDetailsTimelineDialog
            idPedido={orderDetails}
            handleClose={() => setOrderDetails(null)}
          />
        ) : null}
      </Container>
    </>
  );
}

export default ConsultaPedidosOmni;
